import React, { useEffect, useRef } from "react";
import silverMapStyles from "./styles.json";

declare global {
  interface Window {
    google: any;
  }
}

type GoogleMapComponentProps = {
  center: { lat: number; lng: number };
  zoom: number;
  height?: string;
};

const GoogleMapComponent: React.FC<GoogleMapComponentProps> = ({
  center,
  zoom,
  height = "400px",
}) => {
  const mapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let map: any = null;
    let marker: any = null;
    let clickListener: any = null;
    let cancelled = false;
    let retryTimeout: ReturnType<typeof setTimeout> | null = null;

    const initMap = async (attemptsLeft = 25) => {
      if (cancelled || !mapRef.current) return;

      // The Google Maps script tag loads asynchronously, so window.google
      // may not exist yet when this effect first runs. Retry briefly
      // instead of giving up permanently on the first check.
      if (!window.google || !window.google.maps) {
        if (attemptsLeft <= 0) return;
        retryTimeout = setTimeout(() => initMap(attemptsLeft - 1), 200);
        return;
      }

      // Load the libraries with the new API
      const { Map } = (await window.google.maps.importLibrary(
        "maps"
      )) as google.maps.MapsLibrary;
      // Effect may have been cleaned up while importLibrary was in flight
      if (cancelled || !mapRef.current) return;
      // const { AdvancedMarkerElement } = (await window.google.maps.importLibrary(
      //   "marker"
      // )) as google.maps.MarkerLibrary;

      map = new Map(mapRef.current, {
        center,
        zoom,
        mapId: "ee02ea5d457ae514", // your Map ID
        // You can keep local styles, or move to cloud styling later
        styles: silverMapStyles as google.maps.MapTypeStyle[],
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: false,
      });

      // Create a custom pin icon (traditional map pin shape) - highlighted version
      const pinPath = "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z";
      
      const pinIcon = {
        path: pinPath,
        fillColor: "#161616",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: height === "200px" ? 1.4 : 1.2, // Larger scale for footer
        anchor: new window.google.maps.Point(12, 22),
        labelOrigin: new window.google.maps.Point(12, 9),
      };

      marker = new window.google.maps.Marker({
        position: center,
        map,
        title: "Meraki Lounge",
        icon: pinIcon,
        label: {
          text: "M",
          color: "#ffffff",
          fontSize: height === "200px" ? "12px" : "11px",
          fontWeight: "bold",
          fontFamily: `"Cinzel", "Times New Roman"`,
        },
        zIndex: 1000, // Ensure it's on top
        optimized: false, // Better rendering
      });

      const myLatlng = { lat: 32.7091321, lng: -117.1553064 };
      const locationName = "Meraki Lounge, Tenth Avenue, San Diego, CA, USA";

      clickListener = map.addListener("click", () => {
        const encodedLocationName = encodeURIComponent(locationName);
        const mapsUrl = `https://www.google.com/maps?q=${encodedLocationName}&ll=${myLatlng.lat},${myLatlng.lng}`;
        window.open(mapsUrl, "_blank");
      });
    };

    // Kick off async init
    void initMap();

    // Cleanup on unmount
    return () => {
      cancelled = true;
      if (retryTimeout) clearTimeout(retryTimeout);
      if (clickListener) clickListener.remove();
      if (marker) {
        marker.map = null;
      }
      // map itself will be GC'd when div is removed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [center.lat, center.lng, zoom]);

  return <div ref={mapRef} style={{ width: "100%", height }} />;
};

export default GoogleMapComponent;
// import React, {useEffect, useRef} from "react"
// import silverMapStyles from "./styles.json"
// function GoogleMapComponent({center, zoom}: any) {
//     const mapRef = useRef<any>(null)

//     useEffect(() => {
//         let mapInstance: any
//         if (window.google) {
//             mapInstance = new window.google.maps.Map(mapRef.current, {
//                 center,
//                 zoom,
//                 styles: silverMapStyles,
//                 streetViewControl: false,
//                 fullscreenControl: false,
//                 mapTypeControl: false,
//                 zoomControl: false,
//             })
//         }
//         new window.google.maps.Marker({
//             position: center,
//             map: mapInstance,
//             label: {
//                 text: "Meraki Lounge",
//                 color: "#161616",
//                 fontSize: "18px",
//                 fontWeight: "bolder",
//                 fontFamily: `"Cinzel", "Times New Roman"`,
//             },
//             icon: {
//                 path: window.google.maps.SymbolPath.BACKWARD_OPEN_ARROW,
//                 scale: 5,
//                 fillColor: "#161616", // Black color
//                 fillOpacity: 1,
//                 strokeWeight: 0,
//             },
//         })

//         mapInstance?.addListener("click", (mapsMouseEvent: any) => {
//             // Close
//             const myLatlng = {lat: 32.7091321, lng: -117.1553064}
//             var locationName = "Meraki Lounge, Tenth Avenue, San Diego, CA, USA"
//             var encodedLocationName = encodeURIComponent(locationName)
//             // Construct the Google Maps URL
//             var mapsUrl = `https://www.google.com/maps?q=${encodedLocationName}&ll=${myLatlng.lat},${myLatlng.lng}`

//             // Open the URL in a new tab
//             window.open(mapsUrl, "_blank")
//         })
//     }, [center, zoom])

//     return <div ref={mapRef} style={{width: "100%", height: "400px"}} />
// }

// export default GoogleMapComponent
